import { useState, useEffect } from "react";
import { Header, Form, Button, Icons, Text } from "../design";
import { useLoop } from "../components/loop-provider";
import { useAxios, handleError, validateEmail } from "../utils/helpers";
import { translate } from "../utils/translations";

function GetSubscriptionLink() {
    const [axios] = useAxios();
    const { myshopify_domain } = useLoop();
    const [preferences, setpreferences]: Array<any> = useState({});
    const [isLoading, setisLoading] = useState(true);

    const [email, setemail] = useState("");
    const [sent, setsent] = useState(false);

    const [showMessage, setshowMessage] = useState(false);
    const [messageSuccess, setmessageSuccess] = useState(true);
    const [message, setmessage] = useState("");

    const loadData = async () => {
        setisLoading(true);
        try {
            let _params: any = {
                domain: myshopify_domain,
            };
            const { data } = await axios.get(
                `${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/store/read_subscription_login_page_preferences?` +
                new URLSearchParams(_params),
            );
            setpreferences(data.data);
        } catch (error) {
            handleError(error, "components/get-subscription-link", "loadData", {
                myshopify_domain,
            });
        }
        setisLoading(false);
    };

    const sendEmail = async () => {
        setisLoading(true);
        if (!validateEmail(email)) {
            setisLoading(false);
            setmessageSuccess(false);
            setshowMessage(true);
            setmessage(translate("login_invalid_email_msg"));
            return;
        }
        try {
            let body: any = {
                email: email,
                myshopify_domain: myshopify_domain,
            };
            const { data }: any = await axios.post(
                `${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/send_login_link_email`,
                body,
            );
            setsent(true);
            setmessageSuccess(data.success);
            setshowMessage(true);
            let _message = translate(data.messageKey, data.placeholders);
            setmessage(_message);
        } catch (error) {
            handleError(error, "components/get-subscription-link", "sendEmail", { myshopify_domain, email });
        }
        setisLoading(false);
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div
            className="d-flex flex-column align-items-center mx-auto text-center loop-customer-portal-body"
            id="loop-login-container"
            style={{ maxWidth: "500px", padding: "60px 10px" }}
        >
            {isLoading ? (
                <Icons.Spinner />
            ) : (
                <div id="loop-login-body">
                    <Header.H2>{translate("login_page_title")}</Header.H2>
                    <div
                        className="mt-4"
                        dangerouslySetInnerHTML={{
                            __html: translate("login_page_description"),
                        }}
                    ></div>
                    <Form.Input
                        className="mt-4"
                        placeholder={translate("login_email_field")}
                        value={email}
                        onChange={(event: any) => {
                            setemail(event.target.value?.trim());
                        }}
                        emailForm={true}
                    />
                    {showMessage ? (
                        <Text.P1 className={"mt-4" + (messageSuccess ? " text-success" : " text-danger")}>
                            {message}
                        </Text.P1>
                    ) : null}
                    <Button size="lg" className="my-4" onClick={sendEmail}>
                        {translate("login_confirm_btn")}
                    </Button>
                    {sent ? (
                        <a
                            className="loop-text-muted mb-4 py-3"
                            href={"mailto:" + preferences.input_subscription_login_link_page_customer_support_email}
                        >
                            <Text.P2>{translate("login_customer_support_btn")}</Text.P2>
                        </a>
                    ) : null}
                </div>
            )}
        </div>
    );
}

export default GetSubscriptionLink;
